(function(){
    'use strict'

    angular
    .module('app.cuentasContables')
    .controller('EditarCuentaContable', EditarCuentaContable);

    EditarCuentaContable.$inject = ['$scope', '$animationsSrv', '$routeParams', 'CuentasContablesService', 'logger', '$location', 'UserInfoService'];

    function EditarCuentaContable($scope, $animationsSrv, $routeParams, CuentasContablesService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.cuentaContable = {
            destino: -1
        };

        vm.cuentaContableId = $routeParams.id ? $routeParams.id : 0;

        getCuentaContable();

        function getCuentaContable(){

            if(vm.cuentaContableId != 0){
                var promise = CuentasContablesService.getById(UserInfoService.getCompaniaId(), vm.cuentaContableId);

                promise
                .then(function(cuentaContable){
                    vm.cuentaContable = cuentaContable;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener la cuenta contable: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        function validateDestino(){
            if(vm.cuentaContable.destino == -1){
                $scope.cuentaContableForm.destino.$setValidity("different", false);
            }
            else{
                $scope.cuentaContableForm.destino.$setValidity("different", true);
            }
        };

        vm.destinoChange = function(){
            validateDestino();
        };

        function doFormValidations(){
            validateDestino();
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.cuentaContableForm.$valid){
                if(!vm.cuentaContable.id){
                    saveCuentaContable();
                }
                else if($scope.cuentaContableForm.$dirty){
                    updateCuentaContable();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveCuentaContable() {
            var promise = CuentasContablesService.save(vm.cuentaContable);
            
            promise
            .then(function(response){
                logger.success('Cuenta Contable creada con éxito.');
                clearCuentaContableData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear la cuenta contable: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateCuentaContable(){
            var promise = CuentasContablesService.update(vm.cuentaContable);
            
            promise
            .then(function(response){
                logger.success('Cuenta Contable modificada con éxito.');
                $location.path('/cuentas-contables');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar la cuenta contable: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearCuentaContableData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.cuentaContable = {
                destino: -1
            };
            // Set back to pristine.
            $scope.cuentaContableForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.cuentaContableForm.$setUntouched();
        };

    }
})();